import axios from 'axios'
import qs from 'qs'
import { getItem } from '@/untils/storage'
import {Message, MessageBox} from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30 * 1000// 30秒请求超时时间
})

const serviceFile = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 60 * 1000,// 30秒请求超时时间
  responseType: 'arraybuffer'
})

// http request 拦截器
service.interceptors.request.use(config => {
    var token = getItem('token');
    if(token){
      config.headers.Authorization = 'Bearer ' + token;
    }
    config.headers.client='web'
    config.headers.version='2.0.2.0905'
    return config;
  },
  err => {
    return Promise.reject(err);
  })
// http request 拦截器
serviceFile.interceptors.request.use(config => {
    var token = getItem('token');
    if(token){
      config.headers.Authorization = 'Bearer ' + token;

    }
    config.headers.client ='web';
    config.headers.version ='2.0.2.0905';
    return config;
  },
  err => {
    return Promise.reject(err);
  })
// http response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code非200是抛错
     */
    const res = response.data
    if (res.code !== 200) {
      /*if (res.code === 10006) {
        MessageBox.confirm(
          '请重新登录',
          '提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      } else {
      }*/
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })

      return Promise.reject(new Error(res.message))
    } else {
      return response
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '请重新登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
      }
    } else if (error.message.indexOf('timeout') !== -1) {
      error.message = '网络链接超时'
    } else {
      error.message = '网络链接错误'
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)


/**
 * 上传文件post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function axiosPostFile (url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data,{headers: {'Content-Type': 'multipart/form-data'}})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 下载文件get请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function axiosGetDownlodaFile (url, params = {}) {
  return new Promise((resolve, reject) => {
    //  {params: params}
    serviceFile.get(url,{params:params}, {headers: {'Content-Type': 'application/json'}})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 下载文件post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function axiosPostDownlodaFile (url, data = {}) {
  return new Promise((resolve, reject) => {
    serviceFile.post(url, data,{headers: {'Content-Type': 'application/json'}})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function axiosPost (url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data, {headers: {'Content-Type': 'application/json'}})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function axiosGet(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, {params: params},{headers: {'Content-Type': 'application/json'}})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        // console.log(params);
        console.log('error:'+error);
        reject(error)
      })
  })
}

/**
 * 封装delete方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function axiosDelete (url, params) {
  return new Promise((resolve, reject) => {
    service.delete(url, { params: params },{headers: {'Content-Type': 'application/json'}})
      .then(response => { // 这里传递的参数不做处理
        resolve(response)
      }, err => {
        reject(err)
      }).catch((error) => {
      reject(error)
    })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function axiosPatch (url, data = {}) {
  return new Promise((resolve, reject) => {
    service.patch(url, data,{headers: {'Content-Type': 'application/json'}})
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}





// WEBPACK FOOTER //
// ./src/untils/http.js